<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row m-0">
        <div class="col-12 p-0">
          <div class="login-card">
            <BaseFormEnt></BaseFormEnt>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import BaseFormEnt from "@/auth/components/BaseFormEnr.vue";
</script>
